if (!customElements.get('ds-social-proof')) {
  class DsSocialProof extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        desktop: '.ds-sp__slider--desktop',
        mobile: '.ds-sp__slider--mobile',
        navDesktop: '.ds-sp__nav--desktop',
        navMobile: '.ds-sp__nav--mobile',
        prev: '[data-ds-sp-prev]',
        next: '[data-ds-sp-next]',
      };

      this.desktopSwiper = null;
      this.mobileSwiper = null;
      this.mq = window.matchMedia('(max-width: 768px)');

      this.init();
    }

    init() {
      if (!window.Swiper) {
        return setTimeout(() => this.init(), 100);
      }

      this.build();
      this.mq.addEventListener('change', () => this.build());
    }

    num(value, fallback) {
      const n = parseFloat(value);
      return Number.isFinite(n) ? n : fallback;
    }

    createSwiper(sliderEl, navEl, config) {
      const gap = this.num(sliderEl.dataset.gap, 16);
      const autoplayEnabled = sliderEl.dataset.autoplay === 'true';
      const autoplayDelay = this.num(sliderEl.dataset.autoplayDelay, 5000);

      const baseConfig = {
        spaceBetween: gap,
        loop: false,
        speed: 500,
        watchOverflow: true,
        a11y: {
          enabled: true,
          containerMessage: sliderEl.getAttribute('aria-label') || undefined,
        },
        navigation: {
          prevEl: navEl ? navEl.querySelector(this.selectors.prev) : null,
          nextEl: navEl ? navEl.querySelector(this.selectors.next) : null,
          disabledClass: 'swiper-button-disabled',
        },
        autoplay: autoplayEnabled
          ? { delay: autoplayDelay, disableOnInteraction: false, pauseOnMouseEnter: true }
          : false,
      };

      return new window.Swiper(sliderEl, Object.assign(baseConfig, config));
    }

    build() {
      const isMobile = this.mq.matches;

      if (isMobile) {
        if (this.desktopSwiper) {
          this.desktopSwiper.destroy(true, true);
          this.desktopSwiper = null;
        }
        if (!this.mobileSwiper) {
          const el = this.querySelector(this.selectors.mobile);
          const nav = this.querySelector(this.selectors.navMobile);
          if (el) {
            this.mobileSwiper = this.createSwiper(el, nav, {
              slidesPerView: this.num(el.dataset.spv, 1.1),
            });
          }
        }
      } else {
        if (this.mobileSwiper) {
          this.mobileSwiper.destroy(true, true);
          this.mobileSwiper = null;
        }
        if (!this.desktopSwiper) {
          const el = this.querySelector(this.selectors.desktop);
          const nav = this.querySelector(this.selectors.navDesktop);
          if (el) {
            this.desktopSwiper = this.createSwiper(el, nav, {
              slidesPerView: this.num(el.dataset.spvBase, 1.5),
              breakpoints: {
                1050: { slidesPerView: this.num(el.dataset.spvDesktop, 2) },
              },
            });
          }
        }
      }
    }
  }

  customElements.define('ds-social-proof', DsSocialProof);
}
